/**
 * @generated SignedSource<<18365e4b010448d59f2005b7206e1f90>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useGetDurationBasedAgendaFilterBarValues_facility$data = {
  readonly copyOverrides: {
    readonly course: {
      readonly plural: string;
      readonly singular: string;
    } | null | undefined;
  };
  readonly courseBuckets: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly startEndTime: {
    readonly endTime: string | null | undefined;
    readonly startTime: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useGetDurationBasedAgendaFilterBarValues_facility";
};
export type useGetDurationBasedAgendaFilterBarValues_facility$key = {
  readonly " $data"?: useGetDurationBasedAgendaFilterBarValues_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetDurationBasedAgendaFilterBarValues_facility">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetDurationBasedAgendaFilterBarValues_facility",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FacilityStartEndTime",
      "kind": "LinkedField",
      "name": "startEndTime",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endTime",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CourseBucketConnection",
      "kind": "LinkedField",
      "name": "courseBuckets",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CourseBucketEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CourseBucket",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FacilityCopyOverrides",
      "kind": "LinkedField",
      "name": "copyOverrides",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NounOverride",
          "kind": "LinkedField",
          "name": "course",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "singular",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plural",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};

(node as any).hash = "6eeae6c3afab82cfaed0779b334e21bf";

export default node;
